import { useMutation } from "@tanstack/react-query";

// biome-ignore lint: lint/suspicious/noExplicitAny
type AsyncFunc = (...args: any[]) => Promise<any>;
export type WithLoading<T extends AsyncFunc> = T & { isLoading: boolean };

export function useWithLoading<F extends AsyncFunc>(f: F): WithLoading<F> {
  const { mutateAsync, isPending } = useMutation<
    ReturnType<F>,
    Error,
    Parameters<F>
  >({
    mutationFn: (params: Parameters<F>) => f(...params),
  });

  const wrappedFunction = ((...args: Parameters<F>): Promise<ReturnType<F>> =>
    mutateAsync(args)) as F;

  return Object.assign(wrappedFunction, { isLoading: isPending });
}
